import { useCallback } from 'react'

import { useContactUs } from '@tribeplatform/react-components/Support'

type TUseUpgradePlanMessage = () => {
  sendUpgradePlanMessage: (targetPlan?: string) => void
}
export const useUpgradePlanMessage: TUseUpgradePlanMessage = () => {
  const { openContactUs } = useContactUs()

  const sendUpgradePlanMessage = useCallback((targetPlan?: string) => {
    // These messages are sent to the Bettermode team. No need to translate.
    openContactUs({
      subject: 'Plan change',
      type: 'Sales',
      description: targetPlan
        ? `I want to know more about the ${targetPlan} plan.`
        : `I want to know more your paid plans.`,
    })
  }, [])

  return {
    sendUpgradePlanMessage,
  }
}
